<div *ngIf="(bankAccounts$ | async)?.length || !showEmptyMessage; else noTotals">
  <ng-container *ngIf="(bankAccountsStatus$ | async) as ocrolusStatus">
    <br>
    <app-alert *ngIf="ocrolusStatus.mostRecentSummaryOutdated" [message]="'Most recent bank statement monthly summary is outdated.'" [level]="'warning'"></app-alert>
    <app-alert *ngIf="ocrolusStatus.ocrolusStatus === 'pending'" [message]="'Bank statements are on their way. Manually entered data could be overwritten or duplicated'" [level]="'warning'"></app-alert>
  </ng-container>

  <!-- bank values -->
  <ng-container *ngIf="!newFdTableView">
    <app-bank-values [bankValues]="(bankValues$ | async)"></app-bank-values>

    <br/>
  </ng-container>

  <div class="tw-relative">
    <!-- bank account tabs -->
    <mat-tab-group
      mat-stretch-tabs="false"
      [(selectedIndex)]="activeTab">
        <ng-container *ngIf="(bankAccounts$ | async) as bankAccounts">
            <mat-tab label="{{account.accountNumber}}" *ngFor="let account of bankAccounts; let i = index">
              <app-bank-account
                *ngIf="i === activeTab"
                [borrowerId]="borrowerId"
                [bankAccount]="account"
                [originalAccount]="getOriginalAccount(account)"
                [editingBankAccountId]="editingBankAccountId"
                [alert]="alert"
                [cloning]="cloning$ | async"
                [documentLinkInfo]="documentLinkInfo$ | async"
                [newFdTableView]="newFdTableView"
                [bankValues]="bankValues$ | async"
                (addingAccount)="addingAccount = true"
                (addingAccountModal)="showAccountAddDialog()"
                (editAccount)="onEditAccount($event)"
                (saveAccount)="onSaveAccount($event)"
                (editSummaries)="onEditSummaries($event)"
                (editSummariesReason)="onEditSummariesReason($event)"
                (cancelEditAccount)="onCancelEdit()"
                (editAccountAndSummaries)="onEditAccountAndSummaries($event)"
                (createMonthlySummary)="onCreateMonthlySummary($event)"
                (removeBankAccount)="onRemoveAccount($event)"
                (createMonthlySummary)="onCreateMonthlySummary($event)"
                (pullSummariesSync)="onPullSummariesSync($event)"
                ></app-bank-account>
            </mat-tab>
        </ng-container>
    </mat-tab-group>

    <div
      [ngClass]="{ 'fill': (bankAccounts$ | async)?.length !== 0 }"
      *ngIf="!readOnly && (addingAccount || !(bankAccounts$ | async)?.length)">
      <app-bank-account-add
        [borrowerId]="borrowerId"
        [showCancel]="(bankAccounts$ | async)?.length !== 0"
        (addAccount)="onAddAccount($event)"
        (cancel)="addingAccount = false">
      </app-bank-account-add>
    </div>
  </div>
</div>

<!-- if empty, show no part of the component, just empty message -->
<ng-template #noTotals>
  <div>
    No monthly totals.
  </div>
</ng-template>
